import React, { useState, useEffect } from 'react';
import { Requirement, RequirementStatus } from '../../types/kyb';
import RequirementsDashboard from './RequirementsDashboard';

interface RequirementsProps {
  initialRequirements: Requirement[];
  onRequirementStatusChange?: (requirementId: number | string, newStatus: string) => void;
}

const Requirements: React.FC<RequirementsProps> = ({
  initialRequirements,
  onRequirementStatusChange
}) => {
  const [requirements, setRequirements] = useState<Requirement[]>(initialRequirements);

  // Update when initial requirements change (e.g. from parent based on chat)
  useEffect(() => {
    setRequirements(initialRequirements);
  }, [initialRequirements]);

  const handleRequirementAction = (requirementId: number | string) => {
    // Find and update the requirement status
    const updatedRequirements = requirements.map(req => {
      if (req.id === requirementId) {
        // Handle different status transitions
        let newStatus: RequirementStatus;
        
        if (req.status === 'in_progress') {
          newStatus = 'completed';
        } else if (req.status === 'pending' || req.status === 'needs_attention') {
          newStatus = 'in_progress';
        } else if (req.status === 'upload') {
          // For upload requirements, we move to in_progress after uploading documents
          newStatus = 'in_progress';
        } else {
          newStatus = req.status;
        }
        
        if (onRequirementStatusChange) {
          onRequirementStatusChange(requirementId, newStatus);
        }
        
        return { ...req, status: newStatus };
      }
      return req;
    });
    
    setRequirements(updatedRequirements as Requirement[]);
  };

  return (
    <RequirementsDashboard
      requirements={requirements}
      onRequirementAction={handleRequirementAction}
    />
  );
};

export default Requirements;